<template>
    <div>
        <!-- <br />
            * The amount shown in EUR is equal to the amount <span> {{ feeRSD / 100 }} RSD </span> -->
        <div class="monri-container">
            <form action="" method="post" id="payment-form">
                <div class="row" id="credit-monri-components-option" style="display: block">
                    <label for="card-element"> </label>
                    <div id="card-element" style="display: block; width: 100%">
                        <!-- A Monri Component will be inserted here. -->
                    </div>
                    <!-- Used to display Element errors. -->
                    <div id="card-errors" role="alert"></div>

                    <label for="pay-cek-element"></label>
                    <div id="pay-cek-element" style="display: block; width: 100%">
                        <!-- A Monri Component will be inserted here. -->
                    </div>
                    <p class="rsd-paragraf">
                        *All payments will be effected in Serbian currency – dinar (RSD). The amount
                        <span>{{ new Intl.NumberFormat("de-DE").format(amountPageRSD) }} RSD</span>
                        your credit card account will be charged for is obtained through the conversion of the price in
                        Euro into Serbian dinar according to the current exchange rate of the Serbian National Bank.
                        When charging your credit card, the same amount is converted into your local currency according
                        to the exchange rate of credit card associations. As a result of this conversion there is a
                        possibility of a slight difference from the original price stated in our web site.
                    </p>
                    <div class="alert-message">
                        <p v-show="message">{{ message }}</p>
                        <div style="display: flex; justify-content: space-between">
                            <!-- <div>
                                <a href="https://www.mastercard.com"
                                    ><img src="@/assets/monri/materica.png" alt="mastercard"
                                /></a>
                                <a href="https://www.visaeurope.com"
                                    ><img src="@/assets/monri/Visa_Brandmark_White_Black.png" alt="visa"
                                /></a>
                                <a><img src="@/assets/monri/DinaCard.png" alt="dina" /></a>
                            </div>
                            <div>
                                <a href="https://www.bancaintesa.rs/"
                                    ><img src="@/assets/monri/intesaw.png" alt="visa"
                                /></a>
                            </div>-->
                        </div>
                    </div>
                    <div class="checkboxTerms" :class="{ 'checkboxTerms-alert': alertCheckbox }">
                        <v-app id="inspire">
                            <v-checkbox @click="termsButton()" />
                        </v-app>
                        <p :class="{ 'checkboxTerms-alert': alertCheckbox }">
                            I have read and understand the
                            <span class="termsConditions" @click="termsOpen">Terms and Conditions</span>
                        </p>
                    </div>
                    <div v-if="!accepted" @click="alertCheckbox = true" class="btn btn-default btn-success">Pay</div>
                    <button v-if="accepted" @click="loading = true" type="submit" class="btn btn-default btn-success">
                        Pay
                    </button>
                    <div class="loader" v-show="loading">
                        <img src="@/assets/Precomp2.gif" alt="" />
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<!-- <script src="https://ipg.monri.com/dist/components.js"></script> -->
<script></script>
<script>
export default {
    name: "MonriPayment",
    props: [
        "choosenFee",
        "choosenFeeAccommodation",
        "email",
        "tournament",
        "name_last",
        "name_first",
        "event_uuid",
        "nick",
        "fide_id",
        "checkboxFide",
        "player_gender_paypal",
        "rating_paypal",
        "rating_b_paypal",
        "rating_r_paypal",
        "title_uuid_paypal",
        "user",
        "currency",
    ],

    data() {
        return {
            order_number_uuid: "",
            valute: "RSD",
            digest: "",
            fullName: "",
            customData: {},
            kurs: "",
            feeRSD: Number,
            amountEUR: false,
            timestamp: "",
            newData: "",
            secret: "",
            client_secret: "",
            declinedMessage: false,
            feeFisk: Number,
            //  message: localStorage.getItem('message')
            message: "",
            accepted: false,
            accepted: false,
            alertCheckbox: false,
            amountPageRSD: Number,
            loading: false,
        };
    },
    beforeDestroy() {
        localStorage.removeItem("message");
    },
    created() {
        let script = document.createElement("script");
        if (
            this.$store.state.current_user.user_uuid == "701ebb66-64c9-11ed-8b34-7ee1ac15c117" ||
            this.$store.state.current_user.user_uuid == "f4209610-1f95-11ed-b2cd-ea36f6c77235" ||
            this.$store.state.current_user.user_uuid == "c9a5c154-d0b9-11ee-a847-66d6ee15200b" ||
            this.$store.state.current_user.user_uuid == "edc5bf26-14e0-11ed-b540-ea36f6c77235"
        ) {
            script.setAttribute("src", "https://ipgtest.monri.com/dist/components.js");
        } else {
            script.setAttribute("src", "https://ipg.monri.com/dist/components.js");
        }
        document.head.appendChild(script);
        // fetch(process.env.VUE_APP_URL + "/kurs/eur", {
        fetch(process.env.VUE_APP_URL + `/currency?code=${this.tournament.price_currency}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then(response => response.json())
            .then(data => (this.kurs = data[0]))
            //   .then(data => console.log("kursevi", data))
            .then(this.prepareData);
    },
    mounted() {
        // console.log("curr",this.currency)
    },

    methods: {
        termsOpen() {
            this.$emit("openTerms");
        },
        termsButton() {
            if (this.alertCheckbox == true) {
                this.alertCheckbox = !this.alertCheckbox;
            }

            this.accepted = !this.accepted;
        },
        // provera() {
        //     let date = new Date();
        //     let nameFull = this.fullName;
        //     let mail = this.email;
        //     let requestId = self.crypto.randomUUID();
        //     let tourName = this.tournament.event_name;
        //     let feeFisk = this.feeFisk;
        //     fetch("https://elefakt.rs/api/v1.0/invoice", {
        //         method: "POST",
        //         headers: {
        //             "Content-Type": "application/json",

        //             authId: "b66c0f2c-908d-4e8a-ac68-568b2b94078b",
        //             requestId: requestId,
        //         },
        //         body: JSON.stringify({
        //             invoiceType: 0,
        //             transactionType: 0,
        //             payment: [
        //                 {
        //                     amount: feeFisk,
        //                     paymentType: 2,
        //                 },
        //             ],
        //             dateAndTimeOfIssue: date,
        //             //  invoiceCounter:
        //             //   invoiceNumber:
        //             cashier: "OutpostApp",
        //             // buyerId: ,
        //             option: {
        //                 nazivKupca: nameFull,
        //                 emailToBuyer: 1,
        //                 buyerEmailAddress: mail,
        //             },
        //             businessName: "OutpostChess doo",
        //             items: [
        //                 {
        //                     name: `Event fee for ${tourName}`,
        //                     unitLabel: "Kol",
        //                     quantity: 1,
        //                     unitPrice: feeFisk,
        //                     totalAmount: feeFisk,
        //                     labels: [
        //                         {
        //                             label: "A",
        //                         },
        //                     ],
        //                 },
        //             ],
        //         }),
        //     });
        // },
        prepareData() {
            sessionStorage.setItem("kurs", this.kurs.exchange_middle);
            let AccFee = this.choosenFeeAccommodation * this.kurs.exchange_middle * 100;
            let RegFee = this.choosenFee * this.kurs.exchange_middle * 100;
            let RegFeeEvent = this.choosenFee;
            let AccFeeEvent = this.choosenFeeAccommodation;

            if (
                this.choosenFeeAccommodation !== "" &&
                this.choosenFeeAccommodation !== undefined &&
                this.choosenFeeAccommodation !== 0 &&
                this.choosenFeeAccommodation !== null
            ) {
                if (localStorage.getItem("id")) {
                    this.customData = {
                        event_uuid: this.event_uuid,
                        player_nick_name: this.nick,
                        user_uuid: localStorage.getItem("id"),
                        items: [
                            { type: "fee_accommodation", amount: AccFee, amount_currency_event: AccFeeEvent },
                            { type: "fee_registration", amount: RegFee, amount_currency_event: RegFeeEvent },
                        ],
                    };
                } else {
                    this.customData = {
                        event_uuid: this.event_uuid,
                        player_nick_name: this.nick,
                        name_first: this.name_first,
                        name_last: this.name_last,
                        email: this.email,
                        fide_id: this.checkboxFide ? "" : this.fide_id,
                        is_rated: this.checkboxFide,
                        player_gender: this.player_gender_paypal,
                        player_rating_standard: this.rating_paypal,
                        player_rating_blitz: this.rating_b_paypal,
                        player_rating_rapid: this.rating_r_paypal,
                        player_title_uuid: this.title_uuid_paypal,
                        items: [
                            { type: "fee_accommodation", amount: AccFee, amount_currency_event: AccFeeEvent },
                            { type: "fee_registration", amount: RegFee, amount_currency_event: RegFeeEvent },
                        ],
                    };
                }
            } else {
                if (localStorage.getItem("id")) {
                    this.customData = {
                        event_uuid: this.event_uuid,
                        player_nick_name: this.nick,
                        user_uuid: localStorage.getItem("id"),
                        items: [{ type: "fee_registration", amount: RegFee, amount_currency_event: RegFeeEvent }],
                    };
                } else {
                    // console.log('1',this.fide_id)
                    // console.log('2',this.checkboxFide)
                    this.customData = {
                        event_uuid: this.event_uuid,
                        player_nick_name: this.nick,
                        name_first: this.name_first,
                        name_last: this.name_last,
                        email: this.email,
                        fide_id: this.checkboxFide ? "" : this.fide_id,
                        is_rated: this.checkboxFide,
                        player_gender: this.player_gender_paypal,
                        player_rating_standard: this.rating_paypal,
                        player_rating_blitz: this.rating_b_paypal,
                        player_rating_rapid: this.rating_r_paypal,
                        player_title_uuid: this.title_uuid_paypal,
                        items: [{ type: "fee_registration", amount: RegFee, amount_currency_event: RegFeeEvent }],
                    };
                }
            }
            // console.log("kagjkagsjk",this.user)

            //   console.log("disko", this.customData);

            window.addEventListener("localstorage-changed", event => {
                this.message = event.detail.storage;
            });

            this.feeRSD = parseInt((this.choosenFee + this.choosenFeeAccommodation) * 100 * this.kurs.exchange_middle);
            this.amountPageRSD = (this.feeRSD / 100).toFixed(2);
            //console.log(this.feeRSD)
            this.feeFisk = this.feeRSD / 100;
            this.order_number_uuid = self.crypto.randomUUID();
            this.fullName = this.name_first + " " + this.name_last;
            if (localStorage.getItem("token")) {
                fetch(process.env.VUE_APP_URL + `/monri-payment-new`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                    body: JSON.stringify({
                        amount: this.feeRSD,
                        order_number: this.order_number_uuid,
                        currency: "RSD",
                        transaction_type: "purchase",
                        order_info: `Fee for event`,
                        scenario: "charge",
                        supported_payment_methods: ["card"],
                        custom_data: this.customData,
                    }),
                })
                    .then(response => response.text())
                    .then(data => (this.secret = data))
                    //.then(data => console.log("secret", data))
                    .then(this.getSecret);
            } else {
                fetch(process.env.VUE_APP_URL + `/monri-payment-new`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        amount: this.feeRSD,
                        order_number: this.order_number_uuid,
                        currency: "RSD",
                        transaction_type: "purchase",
                        order_info: `Fee for event`,
                        scenario: "charge",
                        supported_payment_methods: ["card"],
                        custom_data: this.customData,
                    }),
                })
                    .then(response => response.text())
                    .then(data => (this.secret = data))
                    //.then(data => console.log("secret", data))
                    .then(this.getSecret);
            }
        },
        getSecret() {
            if (localStorage.getItem("token")) {
                this.email = this.user.email;
            } else {
                this.email = this.email;
            }
            this.test_uuid = this.client_secret = JSON.parse(this.secret).test_uuid;

            this.client_secret = JSON.parse(this.secret).new_payment_client_secret;
            this.loadMonri();
        },

        loadMonri() {
            var monri = Monri("7c1eb7efd23f467984c313a42e997daa01019c5c");
            // console.log("prover", this.client_secret);
            var components = monri.components({ clientSecret: this.client_secret });
            // card
            var card = components.create("card", {
                style: {
                    invalid: {
                        color: "#f2358d",
                    },

                    label: {
                        base: {
                            color: "rgba(111, 115, 129, 1)",
                            textTransform: "none",
                            fontFamily: "Arial",
                            fontSize: "12px",
                            fontWeight: "500",
                        },
                        invalid: {
                            color: "#f2358d",
                        },
                    },
                    input: {
                        base: {
                            borderBottom: "1px solid rgba(111, 115, 129, 1)",
                            backgroundColor: "rgba(32, 33, 34, 1)",
                            fontSize: "13px",
                            color: "rgba(255, 255, 255, 0.8)",
                        },
                    },
                },
            });
            card.mount("card-element");
            //onChange validates user input as it is typed
            card.onChange(event => {
                var displayError = document.getElementById("card-errors");
                if (event.error) {
                    console.log("error ocurred", event.error);

                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = "";
                }
            });

            var form = document.getElementById("payment-form");
            let nameFull = this.fullName;
            let mail = this.email;
            let orderInfo = this.tournament.event_name.substring(0, 30);
            let event_uuid = this.tournament.event_uuid;
            let test_uuid = this.test_uuid;
            let secret = this.client_secret;
            let date = new Date();
            let currentUser = this.user.user_uuid;
            let feeFisk = this.feeFisk;
            let uuid = this.test_uuid;
            let declinedText = false;

            let tourName = this.tournament.event_name;
            form.addEventListener("submit", function (event) {
                event.preventDefault();
                const transactionParams = {
                    address: "...",
                    fullName: nameFull,
                    city: "...",
                    zip: "...",
                    phone: "...",
                    country: "...",
                    email: mail,
                    orderInfo: `Registration event fee for ${orderInfo}`,
                };
                //console.log('moski',transactionParams)
                monri.confirmPayment(card, transactionParams).then(function (result) {
                    console.log("result", result);
                    if (result.error) {
                        console.log(esult.error);
                        // Inform the customer that there was an error.
                        //console.log("greska brale", result);
                        var errorElement = document.getElementById("card-errors");
                        errorElement.textContent = result.error.message;
                    } else {
                        handlePaymentResult(result.result);
                    }
                });
            });
            function handlePaymentResult(paymentResult) {
                // Handle PaymentResult
                //  let scores=paymentResult.status

                //  document.body.innerHTML = JSON.stringify(paymentResult, 2);

                if (paymentResult.status == "approved") {
                    console.log(paymentResult);
                    sessionStorage.setItem("orderId", paymentResult.order_number);
                    sessionStorage.setItem("approvalCode", paymentResult.transaction_response.approval_code);
                    sessionStorage.setItem("amountRSD", paymentResult.transaction_response.outgoing_amount);
                    sessionStorage.setItem("createdPayment", paymentResult.transaction_response.created_at);

                    window.location.href = `https://app.outpostchess.com/monri-register-thank-you/${event_uuid}`;

                    // if (localStorage.getItem("token")) {
                    // fetch(process.env.VUE_APP_URL + `/monri-payment-new-step2`, {
                    //     method: "POST",
                    //     headers: {
                    //         "Content-Type": "application/json",
                    //         Authorization: `Bearer ${localStorage.getItem("token")}`,
                    //     },
                    //     body: JSON.stringify({
                    //         client_secret: secret,
                    //         payment_result: paymentResult,
                    //     }),
                    // })
                    //     .then(response => response.json())
                    //     .then(
                    //         (window.location.href = `https://app.outpostchess.com/monri-register-thank-you/${event_uuid}`),
                    //     );
                    // } else {
                    // fetch(process.env.VUE_APP_URL + `/monri-payment-new-step2`, {
                    //     method: "POST",
                    //     headers: {
                    //         "Content-Type": "application/json",
                    //     },
                    //     body: JSON.stringify({
                    //         client_secret: secret,
                    //         payment_result: paymentResult,
                    //     }),
                    // })
                    //     .then(response => response.json())
                    //     .then(
                    //         (window.location.href = `https://app.outpostchess.com/monri-register-thank-you/${event_uuid}`),
                    //     );
                    // }
                } else {
                    localStorage.setItem(
                        "message",
                        `Payment was not successful. Reason: ${paymentResult.response_message}`,
                    );
                    window.dispatchEvent(
                        new CustomEvent("localstorage-changed", {
                            detail: {
                                storage: localStorage.getItem("message"),
                            },
                        }),
                    );
                }
            }
        },
    },
};
</script>
<style scoped>
#pay-cek-component-view {
    padding: 0;
}
#start-payment-button {
    border: 0;
    padding: 0;
    background-color: rgba(255, 255, 255, 0);
    color: rgba(255, 255, 255, 0);
    background-image: url("https://ipgtest.monri.com/dist/pay-cek/badge-250-50.png");
    height: 50px;
    width: 250px;
    cursor: pointer;
}

#start-payment-button.medium {
    background-image: url("https://ipgtest.monri.com/dist/pay-cek/badge-500-100.png");
    height: 100px;
    width: 300px;
}

#start-payment-button.large {
    background-image: url("https://ipgtest.monri.com/dist/pay-cek/badge-1000-200.png");
    height: 200px;
    width: 1000px;
}
.btn {
    width: 100px;
}
.btn-success {
    background-color: #c8a07d;
    border: 1px solid #c8a07d;
}
.btn-success:hover {
    opacity: 0.8;
}
* >>> .total-amount {
    margin-top: 200px;
}
.checkout-address >>> span {
    background-color: #2c2e2f;
    border-radius: 23px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 96%;
    font-weight: 600;
    font-size: 18px;
    font-family: "Red Hat Display", Helvetica, Arial, sans-serif;
}

.checkout-address >>> .total-amount {
    display: none;
}
.checkout-address >>> span:hover {
    filter: brightness(1.2);
}
.checkboxTerms {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
}
.checkboxTerms p {
    font-size: 12px;
    color: #6f7381;
}

.checkout-address >>> button {
    width: 100%;
}
.checkboxTerms >>> .theme--light.v-application .v-application--wrap .theme--light.v-label {
    background-color: #171819 !important;
    color: #6f7381;
    caret-color: #c8a07d !important;
    border: #c8a07d !important;
    font-size: 12px;
}
.checkboxTerms-alert >>> .theme--light.v-application .v-application--wrap .theme--light.v-label {
    color: #f2358d;
}
.checkboxTerms-alert {
    color: #f2358d !important;
}

.checkboxTerms >>> .v-application {
    font-family: sans-serif !important;
}

.checkboxTerms >>> .v-application .primary--text {
    caret-color: #c8a07d !important;
    color: #c8a07d !important;
}
.checkboxTerms >>> .theme--light.v-application {
    background-color: #171819;
}

.checkboxTerms >>> .v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
}
.checkboxTerms >>> .v-messages {
    min-height: 0px;
}

.checkboxTerms >>> .v-input__slot {
    margin-bottom: 0px;
}
.checkboxTerms >>> label {
    margin-bottom: 0px !important;
}
.checkboxTerms >>> .mdi-checkbox-blank-outline::before {
    color: #c8a07d;
}
.checkboxTerms-alert >>> .mdi-checkbox-blank-outline::before {
    color: #f2358d;
}
</style>

<style scoped lang="scss">
.rsd-paragraf {
    font-size: 12px;
    margin-bottom: 10px;
    span {
        color: #11c6d1;
    }
}

.monri-lightbox-button-el span {
    background-color: aqua !important;
}
</style>
<style scoped lang="scss">
.alert-message {
    margin-bottom: 10px;
    color: #f2358d;
    a {
        img {
            margin-right: 10px;
            height: 25px;
            margin-bottom: 20px;
            margin-top: 8px;
        }
    }
}
.loader {
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
        height: 300px;
    }
}
.monri-container {
    margin: auto;
    width: 90%;
    margin-bottom: 30px;
}
.termsConditions:hover {
    color: #ceceda;
    cursor: pointer;
}
.checkout-address {
    margin-left: 14px;
    margin-bottom: 20px !important;
    margin-top: 24px !important;
    button {
        margin-bottom: 20px !important;
        margin-top: 24px !important;
    }
}
</style>
